﻿import AuthManager from './auth-manager';

/**
 * AuthManager plugin
 * @param {Object} app
 * @param {Object} options
 */
export default {
    install: async (app, options) => {
        app.config.globalProperties.$auth = new AuthManager(options);
    }
};